import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store";
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(Vuetify)
Vue.use(VueCookies)

new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js